import { Component } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-connection-lost',
  standalone: true,
  imports: [],
  templateUrl: './connection-lost.component.html',
  styleUrl: './connection-lost.component.scss'
})
export class ConnectionLostComponent {

  constructor(private location: Location){}
 goBack(): void {
    this.location.back();
  }
}
